import { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import { GRAPH_CONSTANTS, whiteBackgroundPlugin } from './constants';
import { LineChartProps } from './types';
import { calculateAverage } from './utils';

const LineChart = ({ scaleX, scaleY, startDate, displayData, options, isDownloadVersion = false }: LineChartProps) => {
	const [xLineAverage, setXLineAverage] = useState<number>(0);

	useEffect(() => {
		setXLineAverage(calculateAverage(displayData));
	}, [displayData]);

	const baseOptions = {
		...(options || {}),
		responsive: !isDownloadVersion,
		scales: { x: scaleX, y: scaleY },
	};

	const baseData = {
		labels: [new Date(startDate), isDownloadVersion ? new Date() : new Date().setDate(new Date().getDate() + 2)],
		datasets: [
			{
				label: '',
				data: displayData,
				borderColor: GRAPH_CONSTANTS.CHART_BORDER_COLOR,
				backgroundColor: GRAPH_CONSTANTS.CHART_BACKGROUND_COLOR,
			},
			{
				label: 'Average',
				data: Array(displayData.length).fill(xLineAverage),
				fill: false,
				borderColor: GRAPH_CONSTANTS.AVERAGE_LINE_COLOR,
				borderDash: GRAPH_CONSTANTS.AVERAGE_LINE_DASH,
			},
		],
	};

	if (isDownloadVersion) {
		return (
			<Line
				options={baseOptions}
				style={{ display: 'none' }}
				plugins={[whiteBackgroundPlugin]}
				data={baseData}
				height={GRAPH_CONSTANTS.CANVAS_HEIGHT}
				width={GRAPH_CONSTANTS.CANVAS_WIDTH}
				id={GRAPH_CONSTANTS.CANVAS_ID}
			/>
		);
	}

	return <Line options={baseOptions} data={baseData} />;
};

export default LineChart;
